// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c1y7","badges":"styles_badges__DvGCe"};